<div class="ya-typography">
  <ya-subheader [hasContent]="false" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="recipeLink">
      <ng-container *ngIf="isSmallView; then smallViewTopTemplate else wideViewTopTemplate"></ng-container>
      <ng-template #smallViewTopTemplate>
        <ng-container *ngIf="hasImage; then Image else NoImage"></ng-container>
        <ng-template #Image>
          <div class="product-image-wrapper" (swiperight)="SwiperNavigateBack()">
            <div class="aspect-ratio-box">
              <div class="aspect-ratio-box-inside">
                <div class="aspect-ration-img-box">
                  <img class="ya_image" [src]="recipeLink.imageUrl" (error)="onImageError($event)" ignore_assets="1"
                    alt="" />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #NoImage>
          <div class="noimage-fake-subheader"></div>
        </ng-template>
        <div class="content-view--small">
          <div class="recipeLink_content">
            <div class="header">
              <div class="title ya-detail-page-header">
                <h2>{{recipeLink.label}}</h2>
              </div>
            </div>
            <div class="product-content" innerHtml="{{recipeDescription}}"></div>
            <ng-container *ngIf="isItemTagEnabled && recipeLink.itemTags && recipeLink.itemTags.length>0">
              <div class="product-content__tags item-tag-container">
                <ng-container *ngIf="itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
                </ng-container>
                <ng-template #iconTagTemplate>
                  <ng-container *ngFor="let itemTag of recipeLink.itemTags">
                    <div class="tag-icon-container">
                      <ng-container *ngIf="itemTag.svgIcon">
                        <div class="inline-icon" [innerHTML]="svgSanitizer(itemTag.svgIcon, itemTag.color)">
                        </div>
                      </ng-container>
                      <span>{{itemTag.label}}</span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #textTagTemplate>
                  <ng-container *ngFor="let itemTag of recipeLink.itemTags">
                    <span class="label-tag">{{itemTag.label}}</span>
                  </ng-container>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
      <ng-template #wideViewTopTemplate>
        <div class="product-content__top">
          <div class="product-image-wrapper product-content__image" (swiperight)="SwiperNavigateBack()">
            <div class="aspect-ratio-box">
              <div class="aspect-ratio-box-inside">
                <div class="aspect-ration-img-box">
                  <ng-container *ngIf="hasImage;then imageTopTemplate else noImageTopTemplate"></ng-container>
                  <ng-template #imageTopTemplate>
                    <img class="ya_image" [src]="recipeLink.imageUrl" (error)="onImageError($event)" ignore_assets="1"
                      alt="" />
                  </ng-template>
                  <ng-template #noImageTopTemplate>
                    <div class="noimage-fake-subheader">
                      <div class="title ya-detail-page-header product__title">
                        <h2>{{recipeLink.label}}</h2>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="product-base-content">
            <div class="product-content__header">
              <div class="title ya-detail-page-header product__title">
                <h2>{{recipeLink.label}}</h2>
              </div>
            </div>
            <div class="product-content__desc product-content" innerHtml="{{recipeDescription}}"></div>
            <ng-container *ngIf="isItemTagEnabled && recipeLink.itemTags && recipeLink.itemTags.length>0">
              <div class="product-content__tags">
                <ng-container *ngIf="itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
                </ng-container>
                <ng-template #iconTagTemplate>
                  <ng-container *ngFor="let itemTag of recipeLink.itemTags">
                    <div class="tag-icon-container">
                      <ng-container *ngIf="itemTag.svgIcon">
                        <div class="inline-icon" [innerHTML]="svgSanitizer(itemTag.svgIcon, itemTag.color)">
                        </div>
                      </ng-container>
                      <span>{{itemTag.label}}</span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #textTagTemplate>
                  <ng-container *ngFor="let itemTag of recipeLink.itemTags">
                    <span class="label-tag">{{itemTag.label}}</span>
                  </ng-container>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
      <div class="content">
        <div class="headline">
          <h2>{{recipeLink.heading}}</h2>
        </div>
        <div class="linked-products-container--grid" [class.grid-customized]="recipeLink.products.length<=2">
          <ng-container *ngFor="let product of recipeLink.products">
            <div class="linked-products-container__item" [class.item-animated]="loadItems">
              <ya-articlecard [product]="product" [isItemTagEnabled]="isItemTagEnabled" [itemTagType]="itemTagType"
                [options]="ArticleCardConfig" [returnItemGroupId]="activeItemGroupId" (beforeNavigate)="passCouponToLinkedProduct($event)"
                (navigationFailed)="revokeCouponFromLinkedProduct($event)">
              </ya-articlecard>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf="recipeLink.dislikeProducts && recipeLink.dislikeProducts.length > 0">
          <div class="disliketag-container">
            <div class="disliketag-content">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-thumb-down"></div>
              <div class="disliketag-text" langkey="phMenu_DislikeSeperator_title"></div>
            </div>
            <mat-divider></mat-divider>
          </div>
          <div class="linked-products-container--grid" [class.grid-customized]="recipeLink.dislikeProducts.length <= 2">
            <ng-container *ngFor="let product of recipeLink.dislikeProducts">
              <div class="linked-products-container__item" [class.item-animated]="loadItems">
                <ya-articlecard [product]="product" [isItemTagEnabled]="isItemTagEnabled" [itemTagType]="itemTagType"
                  [options]="ArticleCardConfig" [returnItemGroupId]="activeItemGroupId" (beforeNavigate)="passCouponToLinkedProduct($event)"
                  (navigationFailed)="revokeCouponFromLinkedProduct($event)">
                </ya-articlecard>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>